import styled from 'styled-components'
import { defaultBorderRadius, grayDark } from 'utils/style-utils'

import { gameImageAspectRatio } from '../styles'

export const ImageBox = styled.div`
  display: block;
  aspect-ratio: ${gameImageAspectRatio};
  background: ${grayDark};
  border-radius: ${defaultBorderRadius};
  margin-bottom: 0.25rem;

  background-size: cover;
  background-position: center;

  overflow: hidden;

  picture img {
    width: 100%;
    height: 100%;
  }
`
